import { __assign, __rest } from "tslib";
import React, { useContext } from "react";
import { isChildOfType } from "../_util/is-child-of-type";
import { useConfig } from "../_util/config-context";
import { RegionOption, RegionOptionContext } from "./RegionOption";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
var RegionPanelHead = React.forwardRef(function RegionPanelHead(_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classPrefix = useConfig().classPrefix;
    if (isChildOfType(children, RegionOption)) {
        return (React.createElement("div", __assign({ ref: ref, className: classPrefix + "-region__title" }, props), children));
    }
    return (React.createElement("div", __assign({ ref: ref, className: classPrefix + "-region__title" }, props),
        React.createElement("div", { className: classPrefix + "-region__title-name" }, children)));
});
RegionPanelHead.displayName = "RegionPanelHead";
var RegionPanelColumn = React.forwardRef(function RegionPanelColumn(_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classPrefix + "-region__col" }, props), children));
});
RegionPanelColumn.displayName = "RegionPanelColumn";
var RegionPanelGroup = React.forwardRef(function RegionPanelGroup(_a, ref) {
    var name = _a.name, children = _a.children, props = __rest(_a, ["name", "children"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classPrefix + "-region__unit" }, props),
        name && React.createElement("div", { className: classPrefix + "-region__type" }, name),
        children));
});
RegionPanelGroup.displayName = "RegionPanelGroup";
/**
 * 地域选择布局面板
 */
export var RegionPanel = forwardRefWithStatics(function RegionPanel(_a, ref) {
    var _b;
    var children = _a.children, props = __rest(_a, ["children"]);
    var classPrefix = useConfig().classPrefix;
    var shortcut = useContext(RegionOptionContext).shortcut;
    var allOptionElement = null;
    var otherChildElements = [];
    React.Children.forEach(children, function (child) {
        if (isChildOfType(child, RegionPanelHead)) {
            allOptionElement = child;
        }
        else {
            otherChildElements.push(child);
        }
    });
    return (React.createElement("div", __assign({ ref: ref, className: classPrefix + "-region" }, props),
        (shortcut === null || shortcut === void 0 ? void 0 : shortcut.title) && ((_b = shortcut === null || shortcut === void 0 ? void 0 : shortcut.options) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement("div", { className: classPrefix + "-region__history" },
            React.createElement(RegionPanelHead, null, shortcut.title),
            React.createElement("div", { className: classPrefix + "-region__list" }, shortcut.options.map(function (option) { return (React.createElement(RegionOption, __assign({ key: option.value }, option))); })))),
        allOptionElement,
        React.createElement("div", { className: classPrefix + "-region__list" }, otherChildElements)));
}, {
    Head: RegionPanelHead,
    Column: RegionPanelColumn,
    Group: RegionPanelGroup,
});
RegionPanel.displayName = "RegionPanel";
//# sourceMappingURL=RegionPanel.js.map